import { goBackByBrowser } from '../../../../lib/browser';
import { DiFiNavBar } from '../../../../components/DiFi/DiFiNavBar';
import { DifiTabs } from '../../components/DifiTabs';
import { location, reactive } from 'cdui-js';
import { DepoRecords } from './DepoRecords';
import { WithRecords } from './WithRecords';

import './style.css';

const FundRecords = () => {
  const rawType = String(location.query.type || 'depo');
  const state = reactive({
    activeTab: rawType === 'deposit' ? 'depo' : rawType,
  });

  const tabs = [
    { label: '入金记录', value: 'depo', render: () => <DepoRecords /> },
    { label: '出金记录', value: 'with', render: () => <WithRecords /> },
  ];

  return (
    <div class="fund-records">
      <DiFiNavBar
        title="资金记录"
        fixed
        class="bg-c"
        onClickLeft={() => {
          goBackByBrowser();
        }}
        right={<div></div>}
      />

      <div style={{ 'margin-top': '54px' }}>
        <DifiTabs active={state.activeTab} tabs={tabs} />
      </div>
    </div>
  );
};

export default FundRecords;
